/**
  @module @ember-data/store
*/

const IDENTIFIERS = new WeakSet();
export default function isStableIdentifier(identifier) {
  return IDENTIFIERS.has(identifier);
}
export function markStableIdentifier(identifier) {
  IDENTIFIERS.add(identifier);
}
export function unmarkStableIdentifier(identifier) {
  IDENTIFIERS.delete(identifier);
}